import api from "@/apis/bussiness/websiteIssuesAPI";
import Crud from "./crudBase";
var crud = new Crud("websiteIssues", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "id",
      code: "code",      
    }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
